module.exports = __webpack_public_path__ + "static/media/page_v2_2.d1289fb0.jpg";